<script setup lang="ts">
import Button from 'primevue/button';

import { useDownloadOffer } from '../composables/useDownloadOffer';
import { useCalculationPdfData } from '../composables/useCalculationPdfData';
import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useClientsStore } from '../store/clients';
import { buildCalculationFileName } from '../utils/calculationFileName';

const { downloadOffer, isPending } = useDownloadOffer();
const { getAgreementData } = useCalculationPdfData();
const { currentCalculation } = useCurrentCalculation();
const clientsStore = useClientsStore();

function handleClick() {
  const calculation = currentCalculation.value;
  const client = calculation?.client_uuid
    ? clientsStore.getClientByUuid(calculation.client_uuid)
    : null;

  const fileName = buildCalculationFileName({
    prefix: 'umowa',
    calculation,
    client,
  });

  downloadOffer(getAgreementData(), fileName);
}
</script>

<template>
  <Button
    class="font-semibold"
    severity="secondary"
    outlined
    size="small"
    :disabled="isPending"
    @click="handleClick"
  >
    <i class="pi pi-file-arrow-up"></i>
    Pobierz umowę
  </Button>
</template>
